export const ACTIVITY_ENDPOINTS = Object.freeze({
  fetchActivityFields: (shortName, renderType = "new") =>
    `/1.0/template/activity/${shortName}/fields?render_type=${renderType}`,
  fetchActivityById: (activityId) => `/1.0/activity/${activityId}`,
  fetchSkillsetTags: () => "/1.0/activity/skillset",
  createActivity: () => "/1.0/activity/new",
  updateActivity: (activityId) => `/1.0/activity/update/${activityId}`,
});